import { ChangeDetectionStrategy, Component, computed, forwardRef, inject, input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InspectionContext } from '@pages/inspection-detail-page-v2/inspection.context';
import { TenantItemDto } from '@artemis-software/wr-api';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';

@Component({
  standalone: false,
  selector: 'wr-inspection-contractor-select',
  templateUrl: './inspection-contractor-select.component.html',
  styleUrl: './inspection-contractor-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InspectionContractorSelectComponent),
      multi: true,
    },
  ],
})

export class InspectionContractorSelectComponent extends AbstractFormControl<string> {

  readonly inspectionContext = inject(InspectionContext);

  readonly showEmptyOption = input(false);

  readonly contractors = computed(() => {
    const tasks = this.inspectionContext.repairTasks();

    const allContractors = tasks
      .map(task => task.contractor)
      .filter((contractor): contractor is TenantItemDto => !!contractor);

    const uniqueContractors = Array.from(new Map(allContractors.map(contractor => [contractor.id, contractor])).values());

    return uniqueContractors.sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  });

}
